import { CompanyAPI } from '@api';

const manualGroupAuthorization = (form) => CompanyAPI.manualGroupAuthorization(form)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { manualGroupAuthorization };
